import React from "react";

import { Props } from "./types";

function ListIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 36 29.25">
      <path
        d="M3.375,3.375A3.375,3.375,0,1,0,6.75,6.75,3.375,3.375,0,0,0,3.375,3.375Zm0,11.25A3.375,3.375,0,1,0,6.75,18a3.375,3.375,0,0,0-3.375-3.375Zm0,11.25A3.375,3.375,0,1,0,6.75,29.25a3.375,3.375,0,0,0-3.375-3.375ZM34.875,27h-22.5a1.125,1.125,0,0,0-1.125,1.125v2.25A1.125,1.125,0,0,0,12.375,31.5h22.5A1.125,1.125,0,0,0,36,30.375v-2.25A1.125,1.125,0,0,0,34.875,27Zm0-22.5h-22.5A1.125,1.125,0,0,0,11.25,5.625v2.25A1.125,1.125,0,0,0,12.375,9h22.5A1.125,1.125,0,0,0,36,7.875V5.625A1.125,1.125,0,0,0,34.875,4.5Zm0,11.25h-22.5a1.125,1.125,0,0,0-1.125,1.125v2.25a1.125,1.125,0,0,0,1.125,1.125h22.5A1.125,1.125,0,0,0,36,19.125v-2.25A1.125,1.125,0,0,0,34.875,15.75Z"
        transform="translate(0 -3.375)"
      />
    </svg>
  );
}

export { ListIcon };
